/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { APIError, ErrorFormater } from '@support/api/common/error.interface';
import { AppConfig } from '@root/app.config';
import { GlobalErrorService } from '@support/shared/widgets/services/global-error.service';

@Component({
  selector: 'tmo-error-message-detail',
  templateUrl: './error-message-detail.component.html',
})
export class ErrorMessageDetailComponent implements OnInit, OnDestroy {
  /**
   * Subject to manage subscriptions
   */
  public ngUnsubscribe: Subject<void>;
  /**
   * Boolean value to maintain production flag .
   */
  public isProdEnabled: boolean;
  /**
   * variable to save error message.
   */
  public customErrorMessage: APIError[];
  /**
   * Boolean value to show/hide error details .
   */
  public showDetails: object;

  /**
   * Input value for errorText
   */
  @Input() public errorText: string;
  /**
   * Input value for errorFormater
   */
  @Input() public errorFormater: ErrorFormater;
  /**
   * Input value for form Name
   */
  @Input() public formName: string;
  /**
   * Input value for modal Name
   */
  @Input() public modalName: string;
  /**
   * To track api error messages
   */
  public pdlApiErrorMessage: APIError;

  @Input() public dormancyCheck?: boolean;

  constructor(
    private appConfig: AppConfig,
    private globalErrorService: GlobalErrorService
  ) {
    this.ngUnsubscribe = new Subject<void>();
    this.showDetails = {};
  }

  @Input()
  public set errorMessage(apiError: APIError[]) {
    this.customErrorMessage = Object.assign([], apiError);
    this.customErrorMessage = this.globalErrorService.checkUserErrorMessage(
      this.customErrorMessage
    );
    if (this.customErrorMessage.length > 0) {
      this.pdlApiErrorMessage = this.customErrorMessage[this.customErrorMessage.length - 1];
    }
    this.globalErrorService.customErrorSubject.next(apiError);
  }

  @Input()
  public errorMessageSize: boolean;
  public ngOnInit(): void {
    this.isProdEnabled = this.appConfig.getConfig('isProdEnabled');
    // this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'errorLoad');
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
